import { CarouselTypes } from '../../consts';

export const button = ({ theme: { colors, cursors }, isCurrent }) => ({
    padding: 3,
    ...cursors.circle,

    tablet: {
        padding: 5,
    },

    ':hover': {
        '> span': {
            background: !isCurrent ? colors.fuchsia : 'none',
            ...cursors.circle,
        },
        '> span > span': {
            display: 'block',
        },
    },
});

export const step = ({ theme: { colors, cursors }, type, isLarge }) => {
    let background;

    if (type === CarouselTypes.GALLERY || type === CarouselTypes.PROCESS) {
        background = colors.white;
    } else if (type === CarouselTypes.CASE_STUDIES) {
        background = colors.blue;
    } else {
        background = colors.black;
    }

    const base = {
        background,
        ...cursors.circle,
        border: 'none',
        display: 'block',
        outline: '0',
        willChange: 'color, font-size',
        transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) background 0.3s',

        ':hover': {
            background: colors.fuchsia,

            '> span': {
                display: 'block',
            },
        },
    };

    if (type === CarouselTypes.WORKSHOP_PROCESS) {
        return {
            ...base,
            background: 'none',
            color: colors.blue,
            fontWeight: 'bold',
            fontSize: '0.8rem',

            tablet: {
                fontSize: '1.125rem',
            },
        };
    }

    if (isLarge) {
        return {
            ...base,
            width: '0.6875rem',
            height: '0.6875rem',
        };
    }

    return {
        ...base,
        width: '0.25rem',
        height: '0.25rem',
    };
};

export const line = ({ theme: { colors }, isLarge, type }) => {
    const base = {
        background: colors.black,
        opacity: 0.2,
        height: '0.0625rem',
    };

    if (type === CarouselTypes.WORKSHOP_PROCESS) {
        return {
            ...base,
            width: '1.5625rem',
            marginLeft: '0.75rem',
            marginRight: '0.75rem',

            tablet: {
                width: '3.5625rem',
                marginLeft: '0.75rem',
                marginRight: '0.75rem',
            },
        };
    }

    if (isLarge) {
        return {
            ...base,
            width: '3.5625rem',
            marginLeft: '0.75rem',
            marginRight: '0.75rem',
        };
    }

    return {
        ...base,
        width: '0.9375rem',
        // marginLeft: '0.25rem',
        // marginRight: '0.25rem',
    };
};

export const number = ({ theme: { colors, cursors }, type, isLarge }) => {
    const base = {
        color: type === CarouselTypes.GALLERY ? colors.white : colors.fuchsia,
        fontWeight: 700,
        background: 'none',
        willChange: 'color, font-size',
        transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
        ...cursors.circle,
    };

    if (type === CarouselTypes.WORKSHOP_PROCESS) {
        return {
            ...base,
            width: 'auto',
            fontSize: '0.8rem',
            border: `0.0625rem solid ${colors.fuchsia}`,
            padding: '5px 15px',

            tablet: {
                fontSize: '1.5rem',
            },
        };
    }

    if (isLarge) {
        return {
            ...base,
            fontSize: '1.5rem',
            border: `0.0625rem solid ${colors.fuchsia}`,
            width: '2.4375rem',
            height: '2.4375rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };
    }

    return {
        ...base,
        border: 'none',
        outline: '0',
    };
};

export const hoverTitle = ({ theme: { colors, fonts } }) => ({
    ...fonts.heroNewBold,
    position: 'absolute',
    display: 'none',
    marginTop: '1.25rem',

    border: `0.0625rem solid ${colors.blue}`,

    color: colors.blue,
    fontWeight: 'bold',
    fontSize: '0.875rem',
    fontStyle: 'italic',

    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingTop: '0.3125rem',
    paddingBottom: '0.3125rem',

    transform: 'translateX(-50%)',

    backgroundColor: colors.white,
});
